export default {
  min: {
    title:
      "Consegna nella tua zona: Importo necessario per raggiungere il valore minimo dell'ordine (Subtotale esclusi costi di consegna e mancia)",
    description:
      'Spiacenti, non puoi ancora ordinare. {{name}} ha impostato un importo minimo di {{threshold}} (esclusi i costi di consegna)',
  },
  max: {
    title: "Valore massimo dell'ordine per la consegna raggiunto (Totale esclusi i costi di consegna)",
    description:
      'Il tuo ordine ha raggiunto il valore massimo consentito di {{threshold}} per la consegna online. Per ordini superiori a questo importo, contattaci direttamente così possiamo organizzare la consegna per te. Grazie per la comprensione!',
  },
};
